import { IconProps } from "./";
import Icon from "./assets/trash_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Trash(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
